import Service from "./Service";
class sideService extends Service {
  getFileContent(filetype: string, filepath: string) {
    return this.get<any>(`/Storage/Index/${filetype}?filepath=${filepath}`, { failTips: false });
  }
  getUploadImg(data: any, id?: string) {
    return this.post<any>(`/Storage/UploadImg?id=${id}`, data, { failTips: false });
  }
  getValidImageUrl() {
    return `${this.format(this.name, "/Common/ValidCode")}?${Math.random()}`;
  }
}
export default new sideService("side");
